/* eslint-disable */
import { defaultApiInstance } from '@/compositions/api';

// params.partnerId — партнёр брони: бэк вернёт справочник этого партнёра + «общие» записи.
export function getVehicles(params = {}) {
  return defaultApiInstance.get(`v1/vehicle`, { params });
}

export function getVehicle(id) {
  return defaultApiInstance.get(`v1/vehicle/${id}`);
}

export function createVehicle(data) {
  return defaultApiInstance.post(`v1/vehicle/create`, JSON.stringify(data));
}

export function updateVehicle(id, data) {
  return defaultApiInstance.put(`v1/vehicle/${id}/update`, JSON.stringify(data));
}

export function deleteVehicle(id) {
  return defaultApiInstance.delete(`v1/vehicle/${id}/delete`);
}
